export default "__VITE_ASSET__f32caabf__"